/* eslint-disable */
import { mapState } from 'vuex'
import CryptoJS from 'crypto-js'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.users.currentUser,
      getUserCompleted: (state) => state.users.getUserCompleted,
    }),
  },
  data() {
    return {
      tawktoScriptLoaded: false,
      metaChatWidgetEnabled: false,
      firstVisit: true,
    }
  },
  watch: {
    tawktoScriptLoaded: 'handleTawktoTrigger',
    getUserCompleted: 'handleTawktoTrigger',
    metaChatWidgetEnabled: 'handleTawktoTrigger',
    firstVisit: 'handleTawktoTrigger',
    $route(to, from) {
      if (from.name && from.name !== 'register') {
        this.firstVisit = false
      }
      this.metaChatWidgetEnabled = to.meta.chatWidgetEnabled
    },
  },
  methods: {
    handleTawktoTrigger() {
      if (this.tawktoScriptLoaded && this.isProduction()) {
        this.triggerTawkto()
      }
    },
    isProduction() {
      return process.env.NODE_ENV === 'production'
    },
    triggerTawkto() {
      if (!window.Tawk_API) return

      window.Tawk_API.hideWidget()

      if (this.getUserCompleted) {
        this.setAttributes()
        if (this.metaChatWidgetEnabled) {
          const showWidget = () => window.Tawk_API.showWidget()
          this.firstVisit ? setTimeout(showWidget, 3000) : showWidget()
        }
      }
    },
    hashInBase64(email) {
      const secretKey = process.env.VUE_APP_TAWK_API_KEY

      if (!secretKey) {
        throw new Error('VUE_APP_TAWK_API_KEY is not defined.')
      }
      if (!email) {
        throw new Error('Email is not provided.')
      }

      const hash = CryptoJS.HmacSHA256(email, secretKey)
      return CryptoJS.enc.Base64.stringify(hash)
    },
    setAttributes() {
      const { currentUser } = this
      const { subscription = {} } = currentUser

      const attributes = {
        name: currentUser.username || '',
        email: currentUser.email || '',
        hash: this.hashInBase64(currentUser.email),
        'user-id': currentUser.id || '',
        'subscription-id': subscription.id || '',
        'subscription-first-billing-date': subscription.firstBillingDate || '',
        'subscription-expires-at': subscription.expiresAt || '',
        'subscription-name': subscription.name || '',
        'subscription-price': subscription.price || '',
        'subscription-billing-period': subscription.billingPeriod || '',
        'subscription-currency': subscription.currency || '',
        'subscription-max-campaigns': subscription.maxCampaigns || '',
      }

      window.Tawk_API.setAttributes(attributes, (error) => {
        if (error) {
          console.error('Tawk.to setAttributes error:', error)
        }
      })
    },
    loadTawktoScript() {
      if (!this.isProduction()) return
      if (document.querySelector('script[src*="tawk.to"]')) {
        return
      }

      window.Tawk_API = window.Tawk_API || {}
      window.Tawk_API.onLoad = () => {
        this.tawktoScriptLoaded = true
      }

      const script = document.createElement('script')
      script.src = 'https://embed.tawk.to/66859ab99d7f358570d6aec4/1i1su8prl'
      script.async = true
      script.charset = 'UTF-8'
      script.setAttribute('crossorigin', '*')
      script.onerror = () => {
        console.error('Failed to load Tawk.to script.')
      }
      document.head.appendChild(script)
    },
  },
  mounted() {
    if (!this.isProduction()) return

    if (window.Tawk_API) {
      this.tawktoScriptLoaded = true
    } else {
      this.loadTawktoScript()
    }
  },
}
